// TODO: Добавить нормальную типизацию
export const checkUnauthorizedRoute = (to: any): boolean =>
  to.meta.middleware?.unauthorizedOnly ?? false;

export const handleUnauthorizedRoute = (
  to: any,
  token: string | null,
  base: string | null,
  next: Function,
): boolean => {
  if (checkUnauthorizedRoute(to) && token) {
    if (base) {
      next({ name: 'Home', params: { base } });
    } else {
      next({ name: 'SelectBase' });
    }

    return true;
  }

  return false;
};